import React from 'react';
import PropTypes from 'prop-types';
import { Badge } from 'reactstrap';
import { NavLink } from 'react-router-dom';

const SidebarLinkCustomIcon = ({
  title, icon, newLink, route, link,
}) => {
  let sidebarEntry;
  const internal = SidebarEntryInternal(icon, title, newLink);

  if (link) {
    sidebarEntry = <a
        href={link}
        target="_blank"
        rel="noopener noreferrer"
    >{ internal }</a>;
  } else {
    sidebarEntry = <NavLink
        to={route}
        activeClassName="sidebar__link-active"
    >{ internal }</NavLink>;
  }

  return sidebarEntry;
};

const SidebarEntryInternal = (icon, title, newLink) => (
    <li className="sidebar__link custom_sidebar_link">
      {icon ? <img src={`/img/icons/${icon}.png`} className={`icons8-${icon}`}/>: ''}
      <p className="sidebar__link-title">
        {title}
        {newLink
            ? <Badge className="sidebar__link-badge"><span>New</span></Badge>
            : ''}
      </p>
    </li>
);

SidebarLinkCustomIcon.propTypes = {
  title: PropTypes.string.isRequired,
  icon: PropTypes.string,
  newLink: PropTypes.bool,
  route: PropTypes.string,
};

SidebarLinkCustomIcon.defaultProps = {
  icon: '',
  newLink: false,
  route: '/',
};

export default SidebarLinkCustomIcon;
